export const ENDPOINTS_MASTER = {
  MASTER: "/tablas-maestras",
  PARAMETERS: "/parametros",
  // COUNTRY_BY_ID: Eliminado - El endpoint /paises/{id}/maestros no existe en el OpenAPI
  // Se debe usar /tablas-maestras con el query param codigoPais
} as const;